import { generateDynamicCSS } from "../ComponentsMap";
import { ComponentService } from "../Services/Axios/Api";

class Sponsers {
    data = {};
    constructor() {
        this.data = {
            id: '8',
            ComponentName: 'SponsersGrid',
            title: 'Sponsers',
            images: [],
            isVisible: true,
            style: {
                SponsorsGridSection: {
                    backgroundColor: '#ffffff'
                }
            }
        };
    }

    // Id   
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }

    // Title
    getTitle() { return this.data.title; }
    setTitle(title) { this.data.title = title; }

    // Images
    getImages() { return [...this.data.images]; }
    setImages(images) { this.data.images = [...images]; }
    
    addImage(imageUrl) {
        if (!this.data.images.includes(imageUrl)) {
            this.data.images = [...this.data.images, imageUrl];
        }
    }

    addImages(imageUrls) {
        const uniqueImages = imageUrls.filter(url => !this.data.images.includes(url));
        this.data.images = [...this.data.images, ...uniqueImages];
    }

    removeImage(imageUrl) {
        this.data.images = this.data.images.filter(img => img !== imageUrl);
    }

    removeImageByIndex(index) {
        if (index >= 0 && index < this.data.images.length) {
            this.data.images = this.data.images.filter((_, i) => i !== index);
        }
    }

    // Visibility
    isVisible() { return this.data.isVisible; }
    setVisibility(isVisible) { this.data.isVisible = isVisible; }
    toggleVisibility() { this.data.isVisible = !this.data.isVisible; }
    getIsVisible() { return this.data.isVisible; }

    // Style
    getStyle() { return this.data.style; }
    setStyle(style) { this.data.style = style; }
    setBackgroundColor(color) { this.data.style.SponsorsGridSection.backgroundColor = color; }

    // Data
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Render Styles
    renderStyles() {
        generateDynamicCSS("SponsorsGridSection", [
            { backgroundColor: this.data.style.SponsorsGridSection.backgroundColor }
        ]);
    }

    // Methods
    async load() {
        try {
            const response = await ComponentService.getComponent(this.data.ComponentName);
            const data = JSON.parse(response[0]?.data);
            this.setData(data);
            this.setId(response[0]?.id);
            this.setTitle(data.title);
            this.setImages(data.images);
            this.setStyle(data.style);
            return JSON.parse(response[0]?.data);
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}

export const createSponsersInstance = () => new Sponsers();
